// Pahnke Movie Night
export const pahnkeMovieNightGitHubPath: string =
  "https://github.com/christiangerbig/pahnke-movie-night";

// Jungle Swap
export const jungleSwapGitHubClientPath: string =
  "https://github.com/christiangerbig/jungle-swap-client";
export const jungleSwapGitHubServerPath: string =
  "https://github.com/christiangerbig/jungle-swap-server";

// Trackertools
export const trackerToolsGitHubPath: string =
  "https://github.com/christiangerbig/Trackertools";

// Resume
export const resumePath: string =
  "https://www.dropbox.com/scl/fi/f8nsepvyi5y8pogtkar5h/CV-Gerbig.pdf?rlkey=6jlaxkifu6k9qw5cubntcaa0l&dl=0";

// LinkedIn
export const linkedInPath: string =
  "https://www.linkedin.com/in/christian-gerbig/";

// GitHub
export const gitHubPath: string = "https://github.com/christiangerbig/";
